export default "__VITE_ASSET__wZbFn6$M__"